"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uuid;

var _visualengineUtils = require("@ali/visualengine-utils");

var _lodash = require("lodash");

var _index = _interopRequireDefault(require("./i18n/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function uuid(uuidPrefix) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (_typeof(uuidPrefix) === 'object') {
    uuidPrefix = '';
    options = uuidPrefix;
  }

  if (!uuidPrefix) uuidPrefix = 'vc_component';
  return _objectSpread({
    name: 'fieldId',
    title: _index.default.get({
      id: 'uuidPropertyUniquelyIdentifies',
      dm: '唯一标识'
    }),
    display: 'inline',
    tip: _index.default.get({
      id: 'uuidPropertyTheUniqueIdentifierOf',
      dm: '组件的唯一标识符，不能够与其它组件重名，不能够为空，且只能够使用以字母开头的，下划线以及数字的组合。'
    }),
    initialValue: function initialValue(value) {
      // if (typeof value === 'string' && value) return value;
      return _visualengineUtils.Util.uniqueId(value, (0, _lodash.camelCase)(uuidPrefix), 'fieldId');
    },
    setter: /*#__PURE__*/React.createElement(_visualengineUtils.TextSetter, {
      placeholder: _index.default.get({
        id: 'uuidPropertyPleaseEnterAUnique',
        dm: '请输入唯一标识'
      })
    })
  }, options);
}

module.exports = exports.default;